export enum QueryWhereCondition {
  And = 'AND',
  Or = 'OR'
}
